<div class="group-container" [ngClass]="{'error': !!errorMessage}">
    @if(eliteFormId && itemIds.length > 0){
    @for (itemIdKey of itemIds; track itemIdKey) {
    <app-elite-form-group-editor-container (onDelete)="onDeleteSection($event)" [eliteFormId]="eliteFormId"
                                           [itemId]="itemIdKey"
                                           [platformDialog]="platformDialogs[itemIdKey][0]" [dialogField]="dialogField">
    </app-elite-form-group-editor-container>
    } @empty {
    } }
    <button type="button" (click)="copySection()" class="action-button"
            matTooltip="Add Section : ({{dialogField.title}})"
            *ngIf="dialogField.fieldValues['IsMultiResponseField']  && !dialogField.fieldValues['IsMultiResponsePage'] && !dialogField.isDisabled" mat-button>Add Section
    </button>
</div>
<mat-error *ngIf="errorMessage" class="error-message">
    {{errorMessage}}
</mat-error>
